import { BaseNetworkActionValidator } from './base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';

export class AlwaysTrueValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    return true;
  }
}
